import { useContext } from 'react'

import UserAgentContext from '~/contexts/UserAgent'

const useUserAgent = () => useContext(UserAgentContext)

export default useUserAgent